/* Avis Judge.me dans « Elles en parlent » : la pagination de l'app est déplacée dans le bloc résumé et affichée « page X / Y ». */
(function () {
  function place() {
    var app = document.querySelector('.ivg-reviews__app'), sum = document.querySelector('#avis .ivg-reviews__summary');
    if (!app || !sum) return;
    var nav = app.querySelector('nav.jm-pagination-controls');
    if (nav && !sum.contains(nav)) { nav.classList.add('ivg-reviews__appnav'); sum.appendChild(nav); }
    /* bouton « Écrire un avis » de l'app : déplacé lui aussi dans le bloc résumé, il ouvre la fenêtre d'avis Judge.me */
    var act = app.querySelector('.jm-action-buttons');
    if (act && !sum.contains(act)) { act.classList.add('ivg-reviews__appact'); sum.appendChild(act); }
    var b = sum.querySelector('.ivg-reviews__appact button');
    if (b && b.textContent.trim() !== 'Laisser un avis') { b.textContent = 'Laisser un avis'; }
    var moved = sum.querySelector('nav.jm-pagination-controls');
    if (!moved) return;
    var pages = [].slice.call(moved.querySelectorAll('.jm-pagination-controls__button--page'));
    if (!pages.length) { moved.parentNode.removeChild(moved); return; }
    var cur = moved.querySelector('.jm-pagination-controls__button--active'), total = pages[pages.length - 1];
    var label = moved.querySelector('.ivg-reviews__appnav-label');
    if (!label) { label = document.createElement('span'); label.className = 'ivg-reviews__appnav-label'; var next = moved.querySelector('.jm-pagination-controls__button--nav:last-of-type'); var row = next ? next.parentNode : moved; if (next) row.insertBefore(label, next); else row.appendChild(label); }
    var text = 'page ' + (cur ? cur.textContent.trim() : '1') + ' / ' + total.textContent.trim();
    if (label.textContent !== text) label.textContent = text;
  }
  function start() {
    var app = document.querySelector('.ivg-reviews__app'); if (!app) return;
    new MutationObserver(place).observe(app, { childList: true, subtree: true });
    var sum = document.querySelector('#avis .ivg-reviews__summary'); if (sum) new MutationObserver(place).observe(sum, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    place();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
